<template>
  <div class="overflow-x-auto">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-gray-50">
        <tr>
          <th
            v-for="col in userCols"
            :key="col.id"
            scope="col"
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            {{ col.title }}
          </th>
          <th scope="col" class="relative px-6 py-3">
            <span class="sr-only">Actions</span>
          </th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr v-for="rfi in rfis" :key="rfi.ROW_ID">
          <td
            v-for="col in userCols"
            :key="col.id"
            class="px-6 py-4 whitespace-nowrap text-sm"
            :class="{
              'font-medium text-gray-900': !['priority', 'status'].includes(
                col.match_key
              ),
              'text-gray-500': ['priority', 'status'].includes(col.match_key),
            }"
          >
            <!-- Special handling for priority -->
            <span
              v-if="col.match_key === 'priority'"
              class="px-2 py-1 text-xs rounded-full"
              :class="priorityClasses(rfi[col.match_key])"
            >
              {{ rfi[col.match_key] }}
            </span>

            <!-- Default rendering for other fields -->
            <template v-else>
              {{ truncateText(rfi[col.match_key]) || "N/A" }}
            </template>
          </td>
          <td
            class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
          >
            <button
              @click="$emit('view-details', rfi)"
              class="inline-flex items-center px-3 py-1.5 rounded-md text-xs font-medium text-white bg-brand-700 hover:bg-brand-800 transition-colors duration-200 mr-4"
            >
              View
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { truncateText } from "@/helpers/text";

export default {
  props: {
    rfis: Array,
    userCols: Array,
  },

  setup() {
    const priorityClasses = (priority) => {
      const priorityMap = {
        High: "bg-red-100 text-red-800",
        Medium: "bg-yellow-100 text-yellow-800",
        Low: "bg-green-100 text-green-800",
        Expedite: "bg-accent-100 text-accent-700",
        Routine: "bg-brand-100 text-brand-700",
      };
      return priorityMap[priority] || "bg-gray-100 text-gray-800";
    };

    return {
      priorityClasses,
      truncateText,
    };
  },
};
</script>